import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ButtonGroup,
  ListGroupItem,
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { paramPropType } from '../hooks';

function ParamsItem({
  value, active, onClick,
  onMoveUp, onMoveDown, canUp, canDown,
}) {
  return (
    <ListGroupItem
      active={active}
      onClick={onClick}
      className="d-flex"
    >
      <span className="text-muted me-2 pe-2 border-end">{value.sort || '!'}</span>
      <span className="flex-fill text-truncate" title={value.name}>{value.name}</span>
      <ButtonGroup size="sm" className="ms-2">
        <Button onClick={onMoveUp} variant="outline-secondary" disabled={!canUp}>
          <FontAwesomeIcon icon={faArrowUp} />
        </Button>
        <Button onClick={onMoveDown} variant="outline-secondary" disabled={!canDown}>
          <FontAwesomeIcon icon={faArrowDown} />
        </Button>
      </ButtonGroup>
    </ListGroupItem>
  );
}

ParamsItem.propTypes = {
  value: paramPropType.isRequired,
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired,
  canUp: PropTypes.bool,
  canDown: PropTypes.bool,
};

ParamsItem.defaultProps = {
  active: false,
  canUp: false,
  canDown: false,
};

export default ParamsItem;
